import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ActionbarOld = styled.div`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;

  position: relative;
  z-index: 100;

  .inner-actionbar {
    position: fixed;
    left: 0;
    right: 0;
    /* bottom: 0; */
    bottom: constant(safe-area-inset-bottom);
    bottom: env(safe-area-inset-bottom);
    width: 100%;
    z-index: 1;
    height: ${mixin.pxToVw('46')};

    .actionbar-main {
      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: #fff;
        bottom: calc(-100% + 1px);
      }

      nav {
        ul {
          background-color: #fff;
          box-shadow: 0px -3px 5px 0px rgba(0, 0, 0, 0.06);
          ${mixin.flex({ justify: 'space-between' })}

          li {
            flex: 1;
            ${mixin.flex({})};

            .btn {
              width: 100%;
              height: ${mixin.pxToVw('46')};

              svg {
                width: ${mixin.pxToVw('32')};
                height: ${mixin.pxToVw('32')};
              }
            }

            &.is-history {
              .img {
                width: ${mixin.pxToVw('26')};
                height: ${mixin.pxToVw('26')};
                border-radius: ${mixin.pxToVw('2')};
                overflow: hidden;

                &::after {
                  content: '';
                  display: block;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  border: ${mixin.pxToVw('1.5')} solid rgba(0, 0, 0, 0.2);
                  border-radius: ${mixin.pxToVw('2')};
                }
              }
            }

            &.active {
              .btn svg {
                path,
                circle,
                rect {
                  fill: #000;
                }
              }

              &.category .btn svg path {
                fill: #fff;
              }

              &.is-history .img::after {
                border: ${mixin.pxToVw('1.5')} solid rgba(0, 0, 0, 1);
              }
            }
          }
        }
      }

      .floating-banner {
        transition: bottom 0.3s;
      }

      .float-btn {
        ${mixin.flex({ direction: 'column', align: 'flex-end' })};
        position: absolute;
        bottom: ${mixin.pxToVw('66')};
        right: ${mixin.pxToVw('16')};
        row-gap: ${mixin.pxToVw('8')};

        .btn-top {
          width: ${mixin.pxToVw('40')};
          height: ${mixin.pxToVw('40')};
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s, visibility 0.3s, bottom 0.3s;

          svg {
            width: 100%;
            height: 100%;
          }

          &.btn-top.active {
            opacity: 1;
            visibility: visible;
          }
        }
      }
    }
  }

  &.is-old-app-iphonex {
    .inner-actionbar {
      bottom: 34px;
    }
  }

  // 안드로이드앱 액션바 위치 보정
  &.is-andrd {
    .inner-actionbar {
      height: 46px;
      bottom: 1px; // 위치 보정

      .actionbar-main {
        nav {
          ul {
            li {
              .btn {
                height: 46px;

                svg {
                  width: 32px;
                  height: 32px;
                  transform: translate(-0.5px, 0.3px); // 위치 보정
                }
              }

              // 위치 보정
              &:first-child .btn svg {
                transform: translate(0, 0px);
              }

              &.is-history {
                .img {
                  width: 26px;
                  height: 26px;
                  border-radius: 2px;

                  &::after {
                    border: 1.5px solid rgba(0, 0, 0, 0.2);
                    border-radius: 2px;
                  }
                }

                // 위치 보정
                .img {
                  transform: translate(-0.7px, 0.5px);
                }
              }

              &.active {
                &.is-history .img::after {
                  border: 1.5px solid rgba(0, 0, 0, 1);
                }
              }
            }
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.sm} {
    .inner-actionbar {
      height: 46px;

      .actionbar-main {
        nav {
          ul {
            li {
              .btn {
                height: 46px;

                svg {
                  width: 32px;
                  height: 32px;
                }
              }

              &.is-history {
                .img {
                  width: 26px;
                  height: 26px;
                  border-radius: 2px;

                  &::after {
                    border: 1.5px solid rgba(0, 0, 0, 0.2);
                    border-radius: 2px;
                  }
                }
              }

              &.active {
                &.is-history .img::after {
                  border: 1.5px solid rgba(0, 0, 0, 1);
                }
              }
            }
          }
        }

        .float-btn {
          bottom: 66px;
          right: 16px;
          row-gap: 8px;

          .btn-top {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
`;
